/**
 * Moves the "View pricing tiers" button beside the price in the Customify buy card.
 *
 * The editor at /apps/customify/view/... is app-proxy content: Customify's own
 * template is rendered inside this theme's layout, so the theme can only emit
 * markup around it, never inside it. snippets/cc-customify-pricing.liquid emits
 * the trigger and its dialog below the app's content, and this lifts the pair up
 * next to #right-side's price.
 *
 * The whole <dialog-component> moves, not just the button, so the component's
 * refs and on:click bindings stay intact — a modal <dialog> renders in the top
 * layer, so sitting inside the sticky card costs it nothing.
 *
 * If the card never renders a price the component stays where Liquid put it and
 * still opens; it is styled for both spots (assets/cc-customify.css).
 *
 * The trust strip's "Get Pricing" button opens the same dialog. The strip is
 * emitted above the app's content and the dialog below it, so the two can't be
 * one component and that button is wired here by hand rather than with on:click.
 */

const PRICE = '#right-side .customify-price';
const PLACED = 'data-cc-placed';

// Held rather than re-queried: Customify rebuilds parts of the buy card, and a
// rebuild that detaches the component would otherwise lose it for good.
const component = document.querySelector('dialog-component.cc-customify-pricing');

/** Puts the component after the price, if it isn't already there. */
function place() {
  if (!component) return;

  const price = document.querySelector(PRICE);

  if (!price || price.nextElementSibling === component) return;

  // Moving the component mutates the tree this observer watches, which would
  // re-enter place on every pass; detaching around our own write keeps it to one.
  observer.disconnect();

  try {
    price.after(component);
    component.setAttribute(PLACED, '');
  } finally {
    observe();
  }
}

// The card is rebuilt as the shopper changes variant, so this observes for the
// life of the page rather than running once on load.
const observer = new MutationObserver(place);

function observe() {
  observer.observe(document.documentElement, { childList: true, subtree: true });
}

observe();
place();

/* Trust-strip "Get Pricing" opens the ladder instead of jumping to the buy card.
   Its href="#right-side" is left in place as the no-JS fallback, and is also what
   runs if dialog.js hasn't upgraded the element yet — it loads as a separate
   module, so showDialog is not guaranteed to exist the moment this does. */
const cta = document.querySelector('.cc-customify-strip__cta');

if (component && cta) {
  cta.setAttribute('aria-haspopup', 'dialog');

  cta.addEventListener('click', (event) => {
    if (typeof component.showDialog !== 'function') return;

    event.preventDefault();
    component.showDialog();
  });
}
